import React, { useEffect, useState } from "react";
import { doc, getDoc } from "firebase/firestore";
import { auth, db } from "../firebaseConfig";
import { onAuthStateChanged, signOut } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";

export default function Profile() {
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [userChecked, setUserChecked] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (!user) {
        navigate("/login");
        return;
      }

      try {
        const profileRef = doc(db, "users", user.uid);
        const snapshot = await getDoc(profileRef);

        if (snapshot.exists()) {
          setProfile(snapshot.data());
        } else {
          setProfile(null);
        }
      } catch (error) {
        console.error("Error fetching profile:", error.message);
        toast.error("Failed to load your profile. Please try again.");
      } finally {
        setLoading(false);
        setUserChecked(true);
      }
    });

    return () => unsubscribe();
  }, [navigate]);

  useEffect(() => {
    if (userChecked && !loading && !profile) {
      navigate("/profile-setup");
    }
  }, [userChecked, loading, profile, navigate]);

  const handleLogout = async () => {
    await signOut(auth);
    navigate("/login");
  };

  if (loading)
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-50">
        <p className="text-gray-500 text-lg font-medium">Loading profile...</p>
      </div>
    );

  if (!profile) return null;

  return (
    <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-brand-light to-gray-100 p-6">
      <div className="bg-white rounded-2xl shadow-xl p-8 w-full max-w-md transform transition-all hover:shadow-2xl">
        <div className="text-center mb-6">
          <div className="mx-auto w-20 h-20 bg-brand text-black rounded-full flex items-center justify-center text-3xl font-bold shadow-md">
            {profile.firstName?.charAt(0).toUpperCase() || "U"}
          </div>
          <h2 className="mt-4 text-2xl font-semibold text-gray-800">
            {profile.firstName} {profile.lastName}
          </h2>
          <p className="text-gray-500 text-sm">{profile.email}</p>
        </div>

        <div className="space-y-3 text-gray-700">
          <div className="flex justify-between border-b pb-2">
            <span className="font-semibold">📞 Phone:</span>
            <span>{profile.phone || "N/A"}</span>
          </div>
          <div className="flex justify-between border-b pb-2">
            <span className="font-semibold">🌍 Country:</span>
            <span>{profile.country || "N/A"}</span>
          </div>
        </div>

        <button
          onClick={handleLogout}
          className="mt-6 w-full bg-brand hover:bg-black hover:text-brand text-black font-semibold py-2 rounded-xl transition duration-300"
        >
          Logout
        </button>
      </div>
    </div>
  );
}
